import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getFuelAuthorizationConfig = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-authorization-config/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel authorization config fetch error:", error);
    throw error;
  }
};

const updateFuelAuthorizationConfig = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-authorization-config/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel authorization config update error:", error);
    throw error;
  }
};

export { getFuelAuthorizationConfig, updateFuelAuthorizationConfig };
